import React from 'react';
import { Link } from 'react-router-dom';
import cn from 'classnames';

import LogoFooterIcon from '../../../assets/icons/footer/LogoFooterIcon';
import CardIcon1 from '../../../assets/icons/footer/CardIcon1';
import CardIcon2 from '../../../assets/icons/footer/CardIcon2';
import CardIcon3 from '../../../assets/icons/footer/CardIcon3';
import CardIcon4 from '../../../assets/icons/footer/CardIcon4';
import CardIcon5 from '../../../assets/icons/footer/CardIcon5';
import CardIcon6 from '../../../assets/icons/footer/CardIcon6';
import CardIcon7 from '../../../assets/icons/footer/CardIcon7';
import CardIcon8 from '../../../assets/icons/footer/CardIcon8';

import styles from './styles.module.scss';

const firstColumnLinks = [
  {
    name: 'Return Policy',
    link: '/legal#return-policy',
  },
  {
    name: 'Privacy Policy',
    link: '/legal#privacy-policy',
  },
  {
    name: 'Terms of Service',
    link: '/legal#terms-of-service',
  },
];

const secondColumnLinks = [
  {
    name: 'Internet & WiFi News & Updates',
    link: 'https://homefi.info/blogs/homefi-blog',
  },
  {
    name: 'Business Internet & Resellers',
    link: 'https://homefi.info/pages/resellers',
  },
  {
    name: 'Referral Program',
    link: 'https://homefinow.bixgrow.com/register',
  },
];

let cardImages = [
  <CardIcon1 />,
  <CardIcon2 />,
  <CardIcon3 />,
  <CardIcon4 />,
  <CardIcon5 />,
  <CardIcon6 />,
  <CardIcon7 />,
  <CardIcon8 />,
];

const Footer = () => {
  const year = new Date().getFullYear();
  const shopifyLink = `https://www.shopify.com/?utm_campaign=poweredby&utm_medium=shopify&utm_source=onlinestore`;
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.logoWrapper}>
          <LogoFooterIcon className={styles.logo} />
        </div>

        <ul className={styles.column1}>
          {firstColumnLinks.map(({ name, link }, i) => (
            <li key={i}>
              <Link to={link}>{name}</Link>
            </li>
          ))}
          <li>
            <a
              href="https://homefi.info/collections/accessories"
              target="_blank"
              rel="noopener noreferrer"
            >
              Accessories
            </a>
          </li>
        </ul>

        <ul className={styles.column2}>
          {secondColumnLinks.map(({ name, link }, i) => (
            <li key={i}>
              <a href={link} target="_blank" rel="noopener noreferrer">
                {name}
              </a>
            </li>
          ))}
        </ul>

        <div className={styles.infoCardsWrapper}>
          <div className={styles.info}>
            <span className={cn('text', styles.copyright)}>
              © {year},&nbsp;
              <a
                href="https://homefi.info"
                target="_blank"
                rel="noopener noreferrer"
              >
                HomeFi
              </a>
            </span>
            <a
              className={styles.shopifyLink}
              href={shopifyLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              Powered by Shopify
            </a>
          </div>

          <ul className={styles.cards}>
            {cardImages.map((icon, i) => (
              <li className={styles.cardItem} key={i}>
                {icon}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
